import { ActionType } from "@ms/planner-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for TrouterStore, for use in the registry */ export const TrouterStoreActionTypes = [
    ActionType.TrouterRegistrationSucceededAction,
    ActionType.TrouterDisconnectedAction,
    ActionType.TrouterSubscriptionSuccessAction,
    ActionType.TrouterSubscriptionFailedAction,
    ActionType.TrouterNotificationReceivedAction
];
